var moduleMap = {
	"./SlgVueFramework": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(645), __webpack_require__.e(813), __webpack_require__.e(396), __webpack_require__.e(918), __webpack_require__.e(699), __webpack_require__.e(137), __webpack_require__.e(579), __webpack_require__.e(593), __webpack_require__.e(351), __webpack_require__.e(638)]).then(() => (() => ((__webpack_require__(7442)))));
	},
	"./styles/main.scss": () => {
		return __webpack_require__.e(954).then(() => (() => ((__webpack_require__(6954)))));
	},
	"./modals/ActionModal": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(645), __webpack_require__.e(369), __webpack_require__.e(396), __webpack_require__.e(593), __webpack_require__.e(130)]).then(() => (() => ((__webpack_require__(2130)))));
	},
	"./modals/ChangeNameModal": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(645), __webpack_require__.e(369), __webpack_require__.e(813), __webpack_require__.e(137), __webpack_require__.e(593), __webpack_require__.e(695)]).then(() => (() => ((__webpack_require__(3695)))));
	},
	"./modals/ConfirmWithTextEntryModal": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(645), __webpack_require__.e(369), __webpack_require__.e(813), __webpack_require__.e(593), __webpack_require__.e(696)]).then(() => (() => ((__webpack_require__(8696)))));
	},
	"./modals/InformationModal": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(645), __webpack_require__.e(369), __webpack_require__.e(396), __webpack_require__.e(593), __webpack_require__.e(577)]).then(() => (() => ((__webpack_require__(9577)))));
	},
	"./modals/SelectModal": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(645), __webpack_require__.e(369), __webpack_require__.e(813), __webpack_require__.e(396), __webpack_require__.e(918), __webpack_require__.e(593), __webpack_require__.e(985)]).then(() => (() => ((__webpack_require__(1985)))));
	},
	"./modals/SnackbarModal": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(898), __webpack_require__.e(593), __webpack_require__.e(525)]).then(() => (() => ((__webpack_require__(8525)))));
	},
	"./modals/TextAreaModal": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(633), __webpack_require__.e(645), __webpack_require__.e(369), __webpack_require__.e(813), __webpack_require__.e(699), __webpack_require__.e(593), __webpack_require__.e(494)]).then(() => (() => ((__webpack_require__(4494)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});